import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Box,
} from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
    setInitiateCall,
    updateCallData,
    updateCallPopup,
} from 'App/store/actions/call.action';
import CallLoading from './CallLoading';

interface CallModalProps {
    user: any;
    booking: any;
    callPopup: boolean | null;
    call: any;
    updateCallData: (data: any) => void;
    updateCallPopup: (show: boolean) => void;
    setInitiateCall: () => void;
}

const CallModal: React.FC<CallModalProps> = ({
    user,
    booking,
    callPopup,
    call,
    updateCallData,
    updateCallPopup,
    setInitiateCall,
}) => {
    const [showModal, setShowModal] = useState<boolean>(false);

    useEffect(() => {
        if (callPopup !== null) {
            setShowModal(callPopup);
        }
    }, [callPopup]);

    const closeModal = () => {
        updateCallPopup(false);
    };

    const callObject = () => {
        let to: any = {};
        debugger;
        if (user.type === 'rider') {
            to.id = booking.driver.id;
            to.name = booking.driver.name;
            to.img = booking.driver.details.img;
            to.mobile = booking.driver.details.mobile;
        } else if (user.type === 'driver') {
            to.id = booking.rider.id;
            to.name = booking.rider.name;
            to.img = booking.rider.details.img;
            to.mobile = booking.rider.details.mobile;
        }
        return {
            status: 'pending',
            id: "call-id-456",
            from: { id: user.id, name: user.name, img: user.img, mobile: user.mobile },
            to: to,
        };
    };

    const callMobile = () => {
        let obj: any = callObject();
        obj.type = 'mobile';
        obj.status = 'incoming';
        updateCallData(obj);
        closeModal();
    };

    const callData = () => {
        let obj: any = callObject();
        obj.type = 'data';
        updateCallData({ ...obj });
        setInitiateCall();
        closeModal();
    };

    const callVici = () => {
        let obj: any = callObject();
        obj.type = 'vici';
        updateCallData({ ...obj });
        closeModal();
    };

    return (
        <>
            <Dialog
                open={showModal}
                onClose={closeModal}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 2,
                    }
                }}
            >
                <DialogTitle>
                    Choose Call Type
                </DialogTitle>
                <DialogContent sx={{ p: 0 }}>
                    <List>
                        {/* Uncomment if you want mobile call option */}
                        {/* <ListItem disablePadding>
            <ListItemButton onClick={callMobile}>
              <ListItemText
                primary="Mobile Call"
                sx={{
                  '& .MuiListItemText-primary': {
                    fontSize: '14px'
                  }
                }}
              />
            </ListItemButton>
          </ListItem> */}
                        <ListItem disablePadding>
                            <ListItemButton onClick={callData}>
                                <ListItemText
                                    primary="Data Call"
                                    sx={{
                                        '& .MuiListItemText-primary': {
                                            fontSize: '14px'
                                        }
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={callVici}>
                                <ListItemText
                                    primary="Vici Call"
                                    sx={{
                                        '& .MuiListItemText-primary': {
                                            fontSize: '14px'
                                        }
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button
                        onClick={closeModal}
                        variant="contained"
                        fullWidth
                        sx={{ mt: 0 }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <CallLoading call={call} />
        </>
    );
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
    updateCallData: (data: any) => dispatch(updateCallData(data)),
    updateCallPopup: (data: boolean) => dispatch(updateCallPopup(data)),
    setInitiateCall: () => dispatch(setInitiateCall()),
});

const mapStateToProps = (state: any) => ({
    user: state.user.user,
    booking: state.booking,
    callPopup: state.call.callPopup,
    call: state.call.call,
});

export default connect(mapStateToProps, mapDispatchToProps)(CallModal);